import React, { Component } from 'react';
import { connect } from 'react-redux';
import TimeEntryInfo from './TimeEntryInfo/TimeEntryInfo';
import BtnTopMenu from './BtnTopMenu/BtnTopMenu';
import { ASSETS_FOLDER, SUB_PAGE } from '../../../../../constants';
import './SceneUI.css';
import FullscreenSwitch from './FullscreenSwitch/FullscreenSwitch';
import { setSubPage } from '../../../../../redux/actions';
import { trackEvent } from '../../../../../utils/Stats';
import MuteSwitch from './MuteSwitch/MuteSwitch';
import * as Features from '../../../../../utils/Features';

class SceneUI extends Component {
  constructor(props) {
    super(props);

    this.handleClickMovie = this.handleClickMovie.bind(this);
    this.handleClickDoc = this.handleClickDoc.bind(this);
    this.handleClickNames = this.handleClickNames.bind(this);
    this.handleClickInfo = this.handleClickInfo.bind(this);
  }

  // -------------------------------------------------------
  // Buttons
  // -------------------------------------------------------

  handleClickMovie() {
    trackEvent('btn', 'film');
  }

  handleClickDoc() {
    trackEvent('btn', 'dokument');
  }

  handleClickNames() {
    this.props.setSubPage(SUB_PAGE.MEMORIAL);
    trackEvent('btn', 'pamatnik');
  }

  handleClickInfo() {
    this.props.setSubPage(SUB_PAGE.INFO);
    trackEvent('btn', 'info');
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const uiActive =
      this.props.sceneVideo.length === 0 && this.props.subSection.length === 0;

    return (
      <React.Fragment>
        <img
          id="logo-main"
          className={uiActive ? 'active' : ''}
          src={`${ASSETS_FOLDER}img/logo-main.png`}
          alt="Dukla 61 - Logo"
        />
        <TimeEntryInfo />
        <div id="menu-top" className={uiActive ? 'active' : ''}>
          <BtnTopMenu id={0} onClick={this.handleClickMovie} />
          <BtnTopMenu id={1} onClick={this.handleClickDoc} />
          <BtnTopMenu id={2} onClick={this.handleClickNames} />
          <BtnTopMenu id={3} onClick={this.handleClickInfo} />
        </div>
        <MuteSwitch active={uiActive} />
        {!Features.features.iOS && <FullscreenSwitch />}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  sceneVideo: state.app.sceneVideo,
  subSection: state.app.subSection,
});

const mapDispatchToProps = dispatch => ({
  setSubPage: pageId => dispatch(setSubPage(pageId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SceneUI);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneUI/SceneUI.js